/**
 * RecordingIndicator — visuele REC-badge tijdens actieve call.
 *
 * Telnyx start recording server-side op `call.answered` (zie
 * api/inbox/telnyx-webhook.ts -> handleCallAnswered). De SDK v2.26 heeft géén
 * toggle, dus dit is alleen een zichtbare indicator — geen knop. GDPR-wise
 * belangrijk: de klant moet kunnen zien dat wij opnemen, en de medewerker ook.
 */

interface RecordingIndicatorProps {
  active: boolean;
  compact?: boolean;
}

export function RecordingIndicator({ active, compact = false }: RecordingIndicatorProps) {
  if (!active) return null;

  if (compact) {
    return (
      <span
        role="status"
        aria-label="Opname actief"
        title="Dit gesprek wordt opgenomen"
        className="inline-flex items-center gap-1 text-[10px] font-semibold text-red-300"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" aria-hidden />
        REC
      </span>
    );
  }

  return (
    <span
      role="status"
      aria-label="Opname actief"
      title="Dit gesprek wordt opgenomen"
      className="inline-flex items-center gap-1.5 px-1.5 py-0.5 rounded bg-red-500/10 text-[10px] font-semibold text-red-200"
    >
      <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" aria-hidden />
      REC
    </span>
  );
}
